import {SystemStatusGroup} from "../../../gd/const/system-status";

export enum PortfolioConditionType {
    MANUAL         = 'manual',
    PROJECT_TYPES  = 'project_types',
    ALL_IN_PARENTS = 'projects_in_folders'
}

export const projectTypeOptions = [
    {value: PortfolioConditionType.MANUAL,            label: "Select manually"},
    {value: PortfolioConditionType.PROJECT_TYPES,     label: "Select by project type"},
    {value: PortfolioConditionType.ALL_IN_PARENTS,    label: "All projects in folder"}
]

export const projectStatusOptions: Option[] = [

    {
        label: "Open",
        value: SystemStatusGroup.OPEN
    },
    {
        label: "Archived / Closed",
        value: SystemStatusGroup.CLOSED
    },
    {
        label: "All",
        value: SystemStatusGroup.ALL
    },
]
